import {PayloadAction, createSlice} from '@reduxjs/toolkit';

import {adminT} from '@/lib/types/admin.types';
import {speculatorT} from '@/lib/types/speculator.types';
import {superAdminT} from '@/lib/types/superAdmin.types';

export type ACCOUNTS = {
  isSpeculator: boolean;
  speculator: speculatorT | null;
  isAdmin: boolean;
  admin: adminT | null;
  isSuperAdmin: boolean;
  superAdmin: superAdminT | null;
  actingAs: 'speculator' | 'admin' | 'superAdmin';
};

const ACCOUNT_INITIAL: ACCOUNTS = {
  isSpeculator: false,
  speculator: null,
  isAdmin: false,
  admin: null,
  isSuperAdmin: false,
  superAdmin: null,
  actingAs: 'speculator',
};

const accountSlice = createSlice({
  name: 'account',
  initialState: {
    ...ACCOUNT_INITIAL,
  },
  reducers: {
    ACCOUNT_UPDATE: (state, action: PayloadAction<{data?: any; prop?: string; value?: string | Date}>) => {
      return (state = {
        ...state,
        ...(action.payload.data ? action.payload.data : null),
        ...(action.payload.prop ? {[action.payload.prop]: action.payload.value} : null),
      });
    },
  },
});

const {ACCOUNT_UPDATE} = accountSlice.actions;

export {accountSlice, ACCOUNT_INITIAL, ACCOUNT_UPDATE};
